"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SFIndexMgr = exports.SFRequest = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const SFRequest = (apiKey, coins) => {
    const tradeRequestParam = {
        market: apiKey.exchange,
        cloudKeyId: apiKey.key_id,
    };
    const coinParams = coins.join(",");
    return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/dual/index/`, tradeRequestParam, {
        base_quote: coinParams,
    }).pipe((0, operators_1.map)((res) => res.indexes));
};
exports.SFRequest = SFRequest;
class SFIndexMgr {
    constructor() {
        this.useCache = new Map();
    }
    configureOb() {
        if (this.ob$) {
            return this.ob$;
        }
        this.ob$ = (0, rxjs_1.timer)(0, 5000).pipe((0, operators_1.exhaustMap)(() => {
            if (!this.apiKey) {
                throw "no apiKey";
            }
            const key = this.apiKey;
            const keys = this.useCache.keys();
            const coins = new Set(keys);
            return (0, trade_utils_lib_1.requestWithRetry)(() => (0, exports.SFRequest)(key, Array.from(coins)), {
                name: "SFRequest",
                maxRetryCount: 2,
            });
        }), (0, operators_1.publishBehavior)(Array()), (0, operators_1.refCount)(), (0, operators_1.catchError)((error) => {
            this.useCache = new Map();
            this.ob$ = undefined;
            throw error;
        }));
        return this.ob$;
    }
    observerCoins(coins, apiKey) {
        this.apiKey = apiKey;
        coins.forEach((coin) => {
            var _a;
            if (this.useCache.has(coin)) {
                const oldCount = (_a = this.useCache.get(coin)) !== null && _a !== void 0 ? _a : 1;
                this.useCache.set(coin, oldCount + 1);
            }
            else {
                this.useCache.set(coin, 1);
            }
        });
        const endAction = () => {
            coins.forEach((coin) => {
                const oldCount = this.useCache.get(coin);
                if (oldCount === undefined || oldCount === 0) {
                    console.error(`SFIndexMgr 计数器不对: ${coin} ==> ${oldCount}`);
                    return;
                }
                const newCount = oldCount - 1;
                if (newCount > 0) {
                    this.useCache.set(coin, newCount);
                }
                else {
                    this.useCache.delete(coin);
                }
            });
        };
        return new rxjs_1.Observable((p) => {
            const sub = this.configureOb().subscribe(p);
            return {
                unsubscribe: () => {
                    endAction();
                    sub.unsubscribe();
                },
            };
        }).pipe((0, operators_1.map)((res) => {
            return res.filter((e) => {
                return coins.findIndex((c) => `${e.base}_${e.quote}` === c) >= 0;
            });
        }));
    }
    observer(base, quote, apiKey) {
        const coin = `${base}_${quote}`;
        return this.observerCoins([coin], apiKey).pipe((0, operators_1.map)((e) => {
            return (e === null || e === void 0 ? void 0 : e.length) ? e[0] : undefined;
        }));
    }
}
exports.SFIndexMgr = SFIndexMgr;
SFIndexMgr.instance = new SFIndexMgr();
